import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import styled from 'styled-components';

import { FileModel, FolderModel } from '../../../../../typings/api/skymap/rest/v1/.common';
import { IntegrationsState } from '../integrations/state/integrations-state';
import { FileManagerDragLayer } from './folder-list-view/file-manager-drag-layer';
import { LeftArea } from './left-area';
import { RightArea } from './right-area';
import { FolderListViewState } from './state/folder-list-view-state';
import { FolderTreeState } from './state/folder-tree-state';

interface Props {
  foldersCheckable?: boolean;
  filesCheckable?: boolean;
  maxFileSelection?: number;
  onCheckedFilesChanged?: (files: FileModel[]) => void;
  onCheckedFoldersChanged?: (folders: FolderModel[]) => void;
  onCurrentFolderIdChanged?: (id?: string) => void;
}

const FileManager = (props: Props) => {
  return (
    <IntegrationsState>
      <FolderTreeState>
        <Component>
          <DndProvider
            backend={HTML5Backend}
            /* Explicit window so the backend uses the same document as the app (required for drop targets to highlight in Vite/ESM). */
            context={typeof window !== 'undefined' ? window : undefined}
          >
            <FileManagerDragLayer />
            <LeftArea />
            <FolderListViewState
              filesCheckable={props.filesCheckable ?? true}
              foldersCheckable={props.foldersCheckable ?? true}
              maxFileSelection={props.maxFileSelection}
              onCheckedFilesChanged={props.onCheckedFilesChanged}
              onCheckedFoldersChanged={props.onCheckedFoldersChanged}
              onCurrentFolderIdChanged={props.onCurrentFolderIdChanged}
            >
              <RightArea />
            </FolderListViewState>
          </DndProvider>
        </Component>
      </FolderTreeState>
    </IntegrationsState>
  );
};

const Component = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  background-color: #fff;

  // Left area.
  ${LeftArea.styled} {
    width: 300px;
    min-width: 300px;
  }

  // Content area.
  ${RightArea.styled} {
    flex: 1;
  }
`;

export { FileManager, Props as FileManagerDialogProps };
